<template>
  <component
    :is="tag"
    v-on="$listeners"
  >
    <b-avatar
      size="42"
      :src="ticket.user.avatar"
      class="badge-minimal"
      variant="transparent"
    />
    <div class="chat-info flex-grow-1">
      <h5 class="mb-0">
        {{ ticket.subject | summaryText(24) }}
      </h5>
      <p class="card-text text-truncate">
        {{ ticket.last_content | summaryText(24) }}
      </p>
    </div>
    <div
      class="chat-meta text-nowrap"
    >
      <small class="float-right mb-25 chat-time">{{ ticket.updated_at | localeDateTime }}</small>
      <b-badge
        pill
        variant="primary"
        class="float-right"
      >
        {{ ticket.display_status }}
      </b-badge>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge } from 'bootstrap-vue'

export default {
  name: 'TicketItem',
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    ticket: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
